import React, { useState, useEffect } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import * as styles from "./stores.styles";
import { withRedux, isMobileDevice } from "helpers";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined";
import Modal from "@material-ui/core/Modal";
import StoreItemOrdering from "../../components/AppView/StoreItemOrdering";
import CloseIcon from "@material-ui/icons/Close";

import Store from "../../components/Editor/EditTemplate/EditStore/Store";

const isMob = isMobileDevice();

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  tableContainer: {
    marginBottom: "30%",
  },

  paper: {
    width: "100%",
    marginTop: theme.spacing(2),
    boxShadow: "none",
  },
  table: {
    maxWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  MuiSvgIcon: {
    fontSize: "1.15rem",
  },
  paginationSpacer: {
    flex: "none",
  },
  paginationToolbar: {
    justifyContent: !isMob ? "center" : "unset",
  },
  MuiTableCell: {
    letterSpacing: 0,
    overflowWrap: "anywhere",
    textAlign: "left",
  },

  icon: {
    backgroundColor: "#465362",
    borderRadius: "100px",
    padding: "3px",
    color: "white",
    // boxShadow: "3px 3px 13px rgb(120 120 120 / 50%)",
  },
  smallIcon: {
    backgroundColor: "#465362",
    borderRadius: "100px",
    color: "white",
    // boxShadow: "3px 3px 13px rgb(120 120 120 / 50%)",
  },
}));

function StoreItemsTable(props) {
  const {
    selectedStore,
    store,
    setSelectedStore,
    accessToken,
    activeApp,
    activeEditor,
    activeApp: { id: appId },
    activeTemplate: { id: templateId },
    actions: { updateActiveEditor, refreshActiveEditor },
    cards,
  } = props;

  const [storeItems, setStoreItems] = useState(null);
  const [showStoreItemOrderingModal, setShowStoreItemOrderingModal] =
    useState(false);
  const activeStoreItem = store[activeEditor];

  // console.log("store");
  // console.dir(store);
  // console.log(store.length);
  // console.log("activeStoreItem");
  // console.dir(activeStoreItem);
  const classes = useStyles();

  let isNewStoreItem = false;
  if (activeStoreItem) {
    isNewStoreItem = activeStoreItem.id === "newStoreItem";
  }

  const toggleStoreItemOrderingModal = () => {
    setShowStoreItemOrderingModal(!showStoreItemOrderingModal);
  };

  const renderStoreItemOrderingModal = () => {
    if (!showStoreItemOrderingModal) return null;
    return (
      <Modal
        open={showStoreItemOrderingModal}
        disableAutoFocus={true}
        // disableBackdropClick={isNewStoreItem}
        onClose={() => toggleStoreItemOrderingModal()}
        style={{
          margin: "auto",
          width: "100%",
          top: "1%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "530px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={toggleStoreItemOrderingModal}
          >
            <CloseIcon></CloseIcon>
          </span>
          <StoreItemOrdering
            storeItems={store}
            closeModal={toggleStoreItemOrderingModal}
            accessToken={accessToken}
          />
        </div>
      </Modal>
    );
  };

  const getStorePages = () => {
    return activeApp.view.templates.filter((t) => t.type === "store");
  };

  const hasPunchcardPage =
    activeApp.view.templates.find((t) => t.type === "punchCard") === undefined
      ? false
      : true;

  const getStoreItems = async () => {
    try {
      const result = await props.actions.getStoreItems(
        appId,
        selectedStore.id,
        accessToken
      );

      setStoreItems(result);
      // setStoreItems([]);

      return result;
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setStoreItems([]);
    getStoreItems();
  }, []);

  const EnhancedTableHead = (props) => {
    return (
      <TableHead>
        <TableRow
          style={{
            textAlign: "left",
            borderBottom: "1pt solid black",
            backgroundColor: "#89d2d3",
            color: "white",
          }}
        >
          {" "}
          <TableCell
            style={{ lineHeight: "0.5em" }}
            className={classes.MuiTableCell}
          >
            <span
              style={{
                padding: "0px 0px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Item Name
            </span>
          </TableCell>{" "}
          <TableCell
            style={{ lineHeight: "0.5em" }}
            className={classes.MuiTableCell}
          >
            <span
              style={{
                padding: "0px 0px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Actions
            </span>
          </TableCell>
        </TableRow>
      </TableHead>
    );
  };

  // useEffect(() => {
  //   return () => {
  //     refreshActiveEditor();
  //   };
  // }, []);

  const toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = props;
    // console.log("toggling active editor");
    updateActiveEditor(idx);
  };

  const addTempStoreItem = () => {
    // console.log("adding temp store item");
    props.actions.addTempStoreItem();
    props.actions.updateActiveEditor("newStoreItem");
  };

  const renderFloatingButton = () => {
    return (
      <styles.FloatingIconBottomRight onClick={addTempStoreItem}>
        <AddOutlinedIcon
          color="secondary"
          fontSize="inherit"
          className={classes.icon}
        ></AddOutlinedIcon>
      </styles.FloatingIconBottomRight>
    );
  };

  const renderBackButton = () => {
    return (
      <styles.FloatingIconTopLeft
        onClick={() => {
          // console.log("back button clicked");
          setSelectedStore(null);
        }}
      >
        <ArrowBackIosOutlinedIcon
          className={classes.icon}
          fontSize="large"
        ></ArrowBackIosOutlinedIcon>
      </styles.FloatingIconTopLeft>
    );
  };

  const renderFloatingReorderButton = () => {
    let liveStoreItems = 0;

    Object.entries(store).forEach((storeItem) => {
      if (storeItem[1].retired === 0) {
        // not retired
        liveStoreItems++;
      }
    });
    if (Object.entries(store).length > 1 && liveStoreItems >= 2) {
      return (
        <styles.FloatingIconTopRight
          onClick={() => toggleStoreItemOrderingModal()}
        >
          <ShuffleIcon
            color="secondary"
            fontSize="large"
            className={classes.icon}
          ></ShuffleIcon>
          {renderStoreItemOrderingModal()}
        </styles.FloatingIconTopRight>
      );
    } else {
      return null;
    }
  };

  const renderStoreItemModal = () => {
    // console.log("rendering modal...");
    return (
      <Modal
        open={activeStoreItem}
        disableAutoFocus={true}
        disableBackdropClick={isNewStoreItem}
        onClose={() => {
          toggleActiveEditor(null);
        }}
        style={{
          top: "0%",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Store
          appId={appId}
          templateId={templateId}
          {...props.actions}
          storeItem={activeStoreItem}
          hasPunchcardPage={hasPunchcardPage}
          punchcards={cards}
          getStorePages={getStorePages}
          isMobileAdminView={true}
          accessToken={accessToken}
        />
      </Modal>
    );
  };

  const isExpired = (storeItem) => {
    if (storeItem.expiration) {
      var expirationDate = new Date(storeItem.expiration);
      var now = new Date();
      if (expirationDate.getTime() < now.getTime()) {
        return true;
      }
    }
    return false;
  };

  const RenderStoreItemRows = () => {
    if (!store) return null;
    // console.log("rendering store items...");

    const sortedIds = [];
    const sortedRanks = [];

    var ranks = new Set();
    var dups = new Set();
    // find dups if any
    Object.keys(store).forEach((id) => {
      const storeItem = store[id];
      if (ranks.has(storeItem.rank)) {
        // found an existing rank
        dups.add(storeItem.rank);
      } else {
        ranks.add(storeItem.rank);
      }
    });

    const dupsArray = [];

    Object.keys(store).forEach((id) => {
      const storeItem = store[id];

      if (
        storeItem.retired ||
        isExpired(storeItem) ||
        storeItem.id === "newStoreItem"
      ) {
        // sortedIds.push(id); // put retired ones at the back
        // console.log("Found a retired item");
        return;
      } else if (storeItem.rank) {
        if (!sortedRanks[storeItem.rank] && !dups.has(storeItem.rank)) {
          sortedRanks[storeItem.rank] = id; // put
        } else {
          dupsArray.push(id);
        }
      } else {
        sortedIds.unshift(id); // put
      }
    });

    sortedRanks.reverse().forEach((id) => {
      sortedIds.unshift(id);
    });

    if (dupsArray.length > 0) {
      dupsArray.forEach((id) => {
        sortedIds.unshift(id);
      });
    }

    return (
      <TableBody>
        {sortedIds.map((id) => {
          const storeItem = store[id];
          const { title, retired } = storeItem;
          if (!retired) {
            return (
              <TableRow hover role="checkbox" tabIndex={-1} key={id}>
                <TableCell width="50%" className={classes.MuiTableCell}>
                  {title}
                </TableCell>
                <TableCell width="50%" className={classes.MuiTableCell}>
                  <a
                    onClick={(e) => {
                      // setActiveStoreItem(item);
                      toggleActiveEditor(id);
                    }}
                    style={{ textDecoration: "underline" }}
                  >
                    Edit
                  </a>
                </TableCell>
              </TableRow>
            );
          }
        })}
      </TableBody>
    );
  };

  if (!store) return null;
  // if (store.length < 1 || store.length === undefined)
  //   return (
  //     <div className={styles.textContainerTop}>
  //       <Paper className={classes.paper}>
  //         {" "}
  //         <styles.P style={{ textAlign: "center" }}>
  //           You do not have any store items created.
  //         </styles.P>
  //       </Paper>
  //       {renderFloatingButton()}
  //       {renderStoreItemModal()}
  //     </div>
  //   );

  return (
    <div>
      <TableContainer className={classes.tableContainer}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
          style={{
            borderCollapse: "collapse",
            margin: "auto",
            tableLayout: "fixed",
          }}
        >
          <EnhancedTableHead classes={classes} />
          {RenderStoreItemRows()}
        </Table>
      </TableContainer>
      {renderFloatingButton()}
      {renderFloatingReorderButton()}
      {renderStoreItemModal()}
      {renderBackButton()}
    </div>
  );
}

export default withRedux(StoreItemsTable);
